import { ComponentType, useMemo } from "react";
import {
  BoardOfDirectorsContent,
  LeadershipWordContent,
  SubsidiariesContent,
  SocialResponsibilityContent,
} from "../components";
import { TAB_KEYS, TabContentProps, TabKey } from "../types";

/**
 * Custom hook for managing tab content rendering
 * Provides the content component mapping and rendering logic
 */
export function useTabContent() {
  /**
   * Maps tab keys to their corresponding content components
   * This makes it easy to add new tabs or modify existing ones
   */
  const tabContentMap: Record<TabKey, ComponentType<TabContentProps>> = useMemo(
    () => ({
      [TAB_KEYS.BOARD_OF_DIRECTORS]: BoardOfDirectorsContent,
      [TAB_KEYS.LEADERSHIP_WORD]: LeadershipWordContent,
      [TAB_KEYS.SOCIAL_RESPONSIBILITY]: SocialResponsibilityContent,
      [TAB_KEYS.SUBSIDIARIES]: SubsidiariesContent,
    }),
    [],
  );

  /**
   * Get the appropriate content component for a given tab
   * @param activeTab - The currently active tab
   * @returns The content component for the active tab
   */
  const getContentComponent = (activeTab: TabKey) => {
    return (
      tabContentMap[activeTab] || tabContentMap[TAB_KEYS.BOARD_OF_DIRECTORS]
    );
  };

  return {
    getContentComponent,
  };
}
